import Paginator from './models/Paginator'
import { getPath } from '@/api/common'

export default {

  namespaced: true,

  state: {
    vulnerabilities: new Paginator()
  },

  mutations: {
    setVulnerabilities: (state, payload) => state.vulnerabilities = payload
  },

  actions: {
    loadPaginatedVulnerabilities: ({commit}, path) => new Promise((resolve, reject) => {
      getPath(path, ({data}) => {
        commit('setVulnerabilities', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    vulnerabilities: state => state.vulnerabilities
  }

}